export type UmpireIncidentVerificationStatus =
  | 'var_allowed'
  | 'var_disallowed'
  | 'var_verification';
